document.querySelectorAll('[data-carousel-track]').forEach((track) => {
  // Mouse drag-to-scroll, same pattern as .spg-rel-track on the product
  // page (sections/claude-default-product.liquid) - scroll-snap is
  // switched off for the duration of the drag so it doesn't fight the
  // manual scrollLeft assignment, which is what made touch/mouse
  // dragging feel stuck.
  let isDown = false;
  let startX = 0;
  let scrollStart = 0;
  let dragMoved = false;

  track.addEventListener('mousedown', (e) => {
    isDown = true;
    dragMoved = false;
    track.classList.add('is-dragging');
    startX = e.pageX;
    scrollStart = track.scrollLeft;
  });
  window.addEventListener('mouseup', () => {
    isDown = false;
    track.classList.remove('is-dragging');
  });
  window.addEventListener('mouseleave', () => {
    isDown = false;
    track.classList.remove('is-dragging');
  });
  track.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 5) dragMoved = true;
    track.scrollLeft = scrollStart - dx;
  });
  track.addEventListener('click', (e) => {
    if (dragMoved) {
      e.preventDefault();
      e.stopPropagation();
      dragMoved = false;
    }
  }, true);
  track.addEventListener('touchstart', () => track.classList.add('is-dragging'), { passive: true });
  track.addEventListener('touchend', () => track.classList.remove('is-dragging'));

  const thumb = track.parentElement.querySelector('[data-carousel-thumb]');
  if (!thumb) return;

  const update = () => {
    const scrollable = track.scrollWidth - track.clientWidth;
    const widthPct = Math.min(100, (track.clientWidth / track.scrollWidth) * 100);
    const leftPct = scrollable > 0 ? (track.scrollLeft / scrollable) * (100 - widthPct) : 0;
    thumb.style.width = widthPct + '%';
    thumb.style.transform = `translateX(${(leftPct / widthPct) * 100}%)`;
    track.toggleAttribute('data-scrollable', scrollable > 0);
  };

  // Dragging (or just tapping) the purple bar scrubs the carousel to the
  // matching position, same idea as a native scrollbar/video seek bar.
  const scrollbar = track.parentElement.querySelector('[data-carousel-scrollbar]');
  if (scrollbar) {
    const scrubToClientX = (clientX) => {
      const rect = scrollbar.getBoundingClientRect();
      const thumbWidthFrac = Math.min(1, track.clientWidth / track.scrollWidth);
      const usableWidth = rect.width * (1 - thumbWidthFrac);
      const fraction = usableWidth > 0
        ? Math.min(1, Math.max(0, (clientX - rect.left - (rect.width * thumbWidthFrac) / 2) / usableWidth))
        : 0;
      track.scrollLeft = fraction * (track.scrollWidth - track.clientWidth);
    };

    let scrubbing = false;

    scrollbar.addEventListener('pointerdown', (e) => {
      scrubbing = true;
      scrollbar.setPointerCapture(e.pointerId);
      track.classList.add('is-dragging');
      scrubToClientX(e.clientX);
    });
    scrollbar.addEventListener('pointermove', (e) => {
      if (!scrubbing) return;
      scrubToClientX(e.clientX);
    });
    scrollbar.addEventListener('pointerup', () => {
      scrubbing = false;
      track.classList.remove('is-dragging');
    });
    scrollbar.addEventListener('pointercancel', () => {
      scrubbing = false;
      track.classList.remove('is-dragging');
    });
  }

  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});
